import { LOGO_PATH } from '../constants/logo';

export function Loader() {
  return (
    <div className="relative flex items-center justify-center">
      <div className="absolute h-32 w-32 animate-spin rounded-full border-b-4 border-t-4 border-orange-400"></div>
      <img src={LOGO_PATH} alt="Aye" className="w-22 h-12 rounded-full" />
    </div>
  );
}

export const SkeletonLoader = () => {
  return (
    <div className="flex animate-pulse space-x-4">
      <div className="flex-1 py-4">
        <div className="h-4 rounded bg-gray-200"></div>
      </div>
      <div className="flex-1 py-4">
        <div className="h-4 rounded bg-gray-200"></div>
      </div>
      <div className="flex-1 py-4">
        <div className="h-4 rounded bg-gray-200"></div>
      </div>
      <div className="flex-1 py-4">
        <div className="h-4 rounded bg-gray-200"></div>
      </div>
    </div>
  );
};
